import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus-icon",
  "use": "icon-minus-icon-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-minus-icon\">\n<path d=\"M28.6761 1H1.34277V28.3333H28.6761V1Z\" fill=\"black\" stroke=\"#A7F900\" stroke-width=\"2\" />\n<path d=\"M7.33203 15H23.332\" stroke=\"#A7F900\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol